import React from "react";
import RemisionForm from "../../components/remisiones/RemisionForm";
import "../../styles/remisiones-envio.css";

export default function RemisionesEnvioView() {
  return (
    <div className="remisiones-envio-view">
      <RemisionForm />
    </div>
  );
}
